import React from 'react';
import {
  Card,
  CardBody,
  Heading,
  VStack,
  Text,
  Divider,
  HStack
} from '@chakra-ui/react';
import { INPUT_FIELD_TYPE } from '@components/DynamicFormField/constant';
import { Field, CurrencyAccordion, AddCurrencyBar } from './components';

export const MarketRatesCard = ({ data, isEditMode, onChange, onCurrencyChange, onAddCurrency }) => {
  return (
    <Card bg="backGround" borderColor="brand.500" borderWidth="2px" shadow="xl">
      <CardBody>
        <VStack alignItems="stretch" gap={2}>
          <Heading size="md" color="colorPrimary">Market Rates</Heading>

          <Text fontSize="xs" color="gray.400">Configure market rate settings</Text>
          <Divider borderColor="whiteAlpha.300" />


          {/* Currency Section */}
          <HStack justify="space-between">
            <Text fontSize="sm" fontWeight="semibold" color="gray.300">Currencies</Text>
            {isEditMode && <AddCurrencyBar onAdd={(c) => onAddCurrency('marketRates', c)} existingCurrencies={data.currencies} />}
          </HStack>
          <CurrencyAccordion
            currencies={data.currencies}
            isEditMode={isEditMode}
            renderFields={(currency, currencyData) => (
              <>
                <Field
                  field={{ name: 'forceEnabled', label: 'Force Enabled', fieldType: INPUT_FIELD_TYPE.SWITCH }}
                  value={currencyData.forceEnabled ?? false}
                  editable={isEditMode}
                  onChange={(e) =>
                    onCurrencyChange('marketRates', currency, 'forceEnabled', e.target.checked)
                  }
                />

                <Field
                  field={{
                    name: 'allowedDeviationLowerBound',
                    label: 'Allowed Deviation Lower Bound (%)',
                    fieldType: INPUT_FIELD_TYPE.INPUT,
                    inputType: 'number'
                  }}
                  value={currencyData.allowedDeviationLowerBound != null ? (currencyData.allowedDeviationLowerBound * 100) : ''}
                  editable={isEditMode}
                  onChange={(e) => {
                    const val = e.target.value;
                    const decimalVal = val === '' ? 0 : Number(val) / 100;
                    onCurrencyChange('marketRates', currency, 'allowedDeviationLowerBound', decimalVal);
                  }}
                />

                <Field
                  field={{
                    name: 'allowedDeviationUpperBound',
                    label: 'Allowed Deviation Upper Bound (%)',
                    fieldType: INPUT_FIELD_TYPE.INPUT,
                    inputType: 'number'
                  }}
                  value={currencyData.allowedDeviationUpperBound != null ? (currencyData.allowedDeviationUpperBound * 100) : ''}
                  editable={isEditMode}
                  onChange={(e) => {
                    const val = e.target.value;
                    const decimalVal = val === '' ? 0 : Number(val) / 100;
                    onCurrencyChange('marketRates', currency, 'allowedDeviationUpperBound', decimalVal);
                  }}
                />
              </>
            )}
          />



          {/* Global Fields */}
          <Field
            field={{
              name: 'stalenessThreshold',
              label: 'Staleness Threshold',
              fieldType: INPUT_FIELD_TYPE.INPUT,
              inputType: 'number'
            }}
            value={data.stalenessThreshold ?? ''}
            editable={false} // intentional (can be changed when required)
            onChange={(e) => {
              const val = e.target.value;
              onChange('marketRates', 'stalenessThreshold', val === '' ? 0 : val);
            }}
          />

          <Field
            field={{
              name: 'vanceRatesStalenessThreshold',
              label: 'Vance Rates Staleness Threshold',
              fieldType: INPUT_FIELD_TYPE.INPUT,
              inputType: 'number'
            }}
            value={data.vanceRatesStalenessThreshold ?? ''}
            editable={false}
            onChange={(e) => {
              const val = e.target.value;
              onChange('marketRates', 'vanceRatesStalenessThreshold', val === '' ? 0 : val);
            }}
          />

          <Field
            field={{
              name: 'sustainRatesAfterSwitchingForMinutes',
              label: 'Sustain Rates After Switching (minutes)',
              fieldType: INPUT_FIELD_TYPE.INPUT,
              inputType: 'number'
            }}
            value={data.sustainRatesAfterSwitchingForMinutes ?? ''}
            editable={false}
            onChange={(e) => {
              const val = e.target.value;
              onChange('marketRates', 'sustainRatesAfterSwitchingForMinutes', val === '' ? 0 : val);
            }}
          />
        </VStack>
      </CardBody>
    </Card>
  );
};
